import { selector } from 'recoil';
import { uploadErrorsState } from 'state/atoms/upload';

export const failedUploadNames = selector({
  key: 'FailedUploadNames',
  get: ({ get }) => {
    const uploadErrors = get(uploadErrorsState);
    return uploadErrors.map((err) => err.fileName);
  },
});
